<elder-table
  matSort
  [selectionVisible]="true"
  [selectionMultiEnabled]="true"
  [data]="populatedSpecs()"
  (itemClick)="openDetail($event)"
>
  <elder-data-toolbar
    *elderTableToolbar
    (requestNew)="create()"
    (requestRemove)="delete($event)"
    [canRemove]="true"
    [canAdd]="true"
    [canMore]="false"
  ></elder-data-toolbar>

  <ng-container matColumnDef="materialId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="materialId" style="width: 20%">
      {{ 'products.title' | translate }}
    </th>
    <td mat-cell *matCellDef="let spec">{{ spec.materialId }}</td>
  </ng-container>
  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'context.description' | translate }}
    </th>
    <td mat-cell *matCellDef="let spec">
      <div class="layout-col">
        <span>{{ spec.material?.description }}</span>
        <span>{{ spec.material?.description2 }}</span>
        <span>{{ spec.material?.description3 }}</span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="presetQuantity">
    <th
      mat-header-cell
      elderNumberCell
      *matHeaderCellDef
      mat-sort-header="presetQuantity"
      style="width: 10%"
    >
      {{ 'context.amount' | translate }}
    </th>
    <td mat-cell elderNumberCell *matCellDef="let spec">
      {{ spec.presetQuantity }}
    </td>
  </ng-container>
  <ng-container matColumnDef="spacer">
    <th mat-header-cell *matHeaderCellDef style="width: 1%"></th>
    <td mat-cell *matCellDef="let spec"></td>
  </ng-container>
</elder-table>
